var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29297 18.9584C3.9513 18.9584 3.66797 18.675 3.66797 18.3334V1.66669C3.66797 1.32502 3.9513 1.04169 4.29297 1.04169C4.63464 1.04169 4.91797 1.32502 4.91797 1.66669V18.3334C4.91797 18.675 4.63464 18.9584 4.29297 18.9584Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6263 13.9583H4.29297C3.9513 13.9583 3.66797 13.675 3.66797 13.3333C3.66797 12.9916 3.9513 12.7083 4.29297 12.7083H13.6263C14.5346 12.7083 14.9596 12.4666 15.043 12.2583C15.1263 12.05 15.0013 11.5833 14.3513 10.9416L13.3513 9.94165C12.943 9.58331 12.693 9.04165 12.668 8.44165C12.643 7.80831 12.893 7.18331 13.3513 6.72498L14.3513 5.72498C14.968 5.10831 15.1596 4.60831 15.068 4.39165C14.9763 4.17498 14.5013 3.95831 13.6263 3.95831H4.29297C3.94297 3.95831 3.66797 3.67498 3.66797 3.33331C3.66797 2.99165 3.9513 2.70831 4.29297 2.70831H13.6263C15.4513 2.70831 16.0346 3.46665 16.2263 3.91665C16.4096 4.36665 16.5346 5.31665 15.2346 6.61665L14.2346 7.61665C14.0263 7.82498 13.9096 8.11665 13.918 8.40831C13.9263 8.65831 14.0263 8.88331 14.2013 9.04165L15.2346 10.0666C16.5096 11.3416 16.3846 12.2916 16.2013 12.75C16.0096 13.1916 15.418 13.9583 13.6263 13.9583Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/flagIcon.e3786822cd70aa9ab3c0095ca9ed568b.svg";
export { ForwardRef as ReactComponent };